module.exports = __webpack_public_path__ + "img/ico-arrow.f1026b2e.svg";